"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _odataQuery = _interopRequireDefault(require("odata-query"));

var _StringHelper = require("../../Utilities/StringHelper");

var _TokenHelper = require("../../Utilities/TokenHelper");

var _User = require("../../Utilities/User");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var OrgService = /*#__PURE__*/function () {
  function OrgService(_ref) {
    var accessToken = _ref.accessToken,
        endpoint = _ref.endpoint,
        idToken = _ref.idToken;
    (0, _classCallCheck2.default)(this, OrgService);
    (0, _defineProperty2.default)(this, "accessToken", "");
    (0, _defineProperty2.default)(this, "idToken", "");
    (0, _defineProperty2.default)(this, "endpoint", "");
    (0, _defineProperty2.default)(this, "headers", new Headers({
      "Cache-Control": "no-cache"
    }));
    this.accessToken = accessToken;
    this.idToken = idToken !== null && idToken !== void 0 ? idToken : "";
    this.endpoint = endpoint;
    this.headers.append("Authorization", "Bearer ".concat(accessToken));
  }

  (0, _createClass2.default)(OrgService, [{
    key: "IsInRole",
    value: function IsInRole(role) {
      return (0, _User.isInRole)(role, this.GetUser());
    }
  }, {
    key: "GetOrganization",
    value: function () {
      var _GetOrganization = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id) {
        var res, _data, errorMessage;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("".concat(this.endpoint, "/Organizations/").concat(encodeURIComponent(id)), {
                  headers: this.headers
                });

              case 3:
                res = _context.sent;
                _context.next = 6;
                return res.json();

              case 6:
                _data = _context.sent;
                return _context.abrupt("return", _data);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                errorMessage = (0, _StringHelper.getStringError)(_context.t0);
                throw new Error("OrgService SDK - GetOrganization: ".concat(errorMessage));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function GetOrganization(_x) {
        return _GetOrganization.apply(this, arguments);
      }

      return GetOrganization;
    }()
  }, {
    key: "GetOrganizationList",
    value: function () {
      var _GetOrganizationList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref2) {
        var _ref2$page, page, _ref2$pageSize, pageSize, order, search, geolocation, skip, top, direction, orderBy, filter, geoParams, query, res, _data2, errorMessage;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref2$page = _ref2.page, page = _ref2$page === void 0 ? 1 : _ref2$page, _ref2$pageSize = _ref2.pageSize, pageSize = _ref2$pageSize === void 0 ? 6 : _ref2$pageSize, order = _ref2.order, search = _ref2.search, geolocation = _ref2.geolocation;
                skip = (page - 1) * pageSize;
                top = pageSize;
                direction = order == null ? "asc" : order.direction || "asc";
                orderBy = (order == null ? "Name" : order.column) + " " + direction;
                filter = search && {
                  or: [{
                    "toupper(Name)": {
                      contains: search.toUpperCase()
                    }
                  }, {
                    FriendlyName: {
                      contains: search.toUpperCase()
                    }
                  }]
                };
                geoParams = geolocation ? "&Latitude=".concat(geolocation.Latitude, "&Longitude=").concat(geolocation.Latitude, "&distance=").concat(geolocation.distance) : "";
                query = (0, _odataQuery.default)({
                  top: top,
                  skip: skip,
                  orderBy: orderBy,
                  filter: filter
                });
                _context2.prev = 8;
                _context2.next = 11;
                return fetch("".concat(this.endpoint, "/Organizations").concat(query + geoParams), {
                  headers: this.headers
                });

              case 11:
                res = _context2.sent;
                _context2.next = 14;
                return res.json();

              case 14:
                _data2 = _context2.sent;
                return _context2.abrupt("return", _data2);

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](8);
                errorMessage = (0, _StringHelper.getStringError)(_context2.t0);
                throw new Error("OrgService SDK - GetOrganizationList: ".concat(errorMessage));

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 18]]);
      }));

      function GetOrganizationList(_x2) {
        return _GetOrganizationList.apply(this, arguments);
      }

      return GetOrganizationList;
    }()
  }, {
    key: "GetUser",
    value: function GetUser() {
      var user;

      if (this.accessToken) {
        var accessPayload = (0, _TokenHelper.decodeToken)(this.accessToken);
        user = _objectSpread(_objectSpread({}, user), {}, {
          accessToken: this.accessToken,
          role: accessPayload.role
        });
      } else {
        // eslint-disable-next-line no-console
        console.error(new Error("Please supply a valid accessToken to OrgService."));
      }

      if (this.idToken) {
        var idPayload = (0, _TokenHelper.decodeToken)(this.idToken);
        var firstName = idPayload["given_name"];
        var lastName = idPayload["family_name"];
        user = _objectSpread(_objectSpread({}, user), {}, {
          email: idPayload.email,
          firstName: firstName,
          id: idPayload.sub,
          idToken: this.idToken,
          lastName: lastName
        });
      } else {
        // eslint-disable-next-line no-console
        console.error(new Error("Please supply idToken to OrgService."));
      }

      return user;
    }
  }, {
    key: "GetUserOrganizationList",
    value: function () {
      var _GetUserOrganizationList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var res, _data3, response, errorMessage;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetch("".concat(this.endpoint, "/Organizations/associatedorganizations"), {
                  headers: this.headers
                });

              case 3:
                res = _context3.sent;

                if (!(res.status !== 200)) {
                  _context3.next = 6;
                  break;
                }

                throw new Error(res.status.toString());

              case 6:
                _context3.next = 8;
                return res.json();

              case 8:
                _data3 = _context3.sent;
                response = {
                  items: _data3,
                  total: _data3.length
                };
                return _context3.abrupt("return", response);

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](0);
                errorMessage = (0, _StringHelper.getStringError)(_context3.t0);
                throw new Error("OrgService SDK - GetUserOrganizationList: ".concat(errorMessage));

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 13]]);
      }));

      function GetUserOrganizationList() {
        return _GetUserOrganizationList.apply(this, arguments);
      }

      return GetUserOrganizationList;
    }()
  }]);
  return OrgService;
}();

exports.default = OrgService;